import React, { PureComponent } from 'react';
import { getTranslate } from 'react-localize-redux';
import { Form, Input, InputNumber } from 'antd';
import { connect } from 'react-redux';

@connect(({ localize }) => ({
  translate: getTranslate(localize)
}))
@Form.create()
export default class Withdrawal extends PureComponent {
  render() {
    const { translate, form } = this.props;
    const { getFieldDecorator } = form;
    const ruleRequired = {
      required: true,
      message: translate('validation.required.default')
    };
    // TODO: take current currency into account
    const minAmount = 25000;

    return (
      <Form>
        <Form.Item className={'amount'} label={translate('withdrawal.amount')}>
          {getFieldDecorator('amount', {
            validateFirst: true,
            rules: [
              ruleRequired,
              {
                validator: (rule, value, callback) => {
                  if (+value >= minAmount) {
                    callback();
                  } else {
                    callback(true);
                  }
                },
                message: translate('validation.invalidMin', {
                  amount: minAmount
                })
              }
            ]
          })(
            <InputNumber
              className={'no-border'}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
              parser={value => value.replace(/\$\s?|(\.*)/g, '')}
              placeholder={translate('withdrawal.amountPlaceHolder')}
            />
          )}
        </Form.Item>
        <Form.Item
          className={'amount-confirm'}
          label={translate('withdrawal.amountConfirm')}
        >
          {getFieldDecorator('amountConfirm', {
            validateFirst: true,
            rules: [
              ruleRequired,
              {
                validator: (rule, value, callback) => {
                  const prevValue = form.getFieldValue('amount');
                  if (+value === +prevValue) {
                    callback();
                  } else {
                    callback(true);
                  }
                },
                message: translate('validation.sameAmount')
              }
            ]
          })(
            <InputNumber
              className={'no-border'}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
              parser={value => value.replace(/\$\s?|(\.*)/g, '')}
              placeholder={translate('withdrawal.amountConfirmPlaceholder')}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}
